import {Client} from '@/models';

export default [
	{
		path: '/clients',
		name: 'clients',
		meta: {
			title: 'Liste des clients',
			granted: [ 'API_GET_CLIENT' ],
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/Client.vue')
	},
	{
		path: '/clients/show/:id',
		name: 'client-show',
		props: {
			slotData: () => ({
				component: import(/* webpackChunkName: "dashboard" */ '../components/Crud/Client/Show.vue'),
				class: Client
			}),
			editRoute: { name: 'client-edit' },
		},
		meta: {
			title: 'Détail d\'un client',
			granted: [ 'API_GET_CLIENT' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/EditShow.vue')
	},
	{
		path: '/clients/edit/:id',
		name: 'client-edit',
		props: {
			slotData: () => ({
				component: import(/* webpackChunkName: "dashboard" */ '../components/Crud/Client/Edit.vue'),
				class: Client
			}),
		},
		meta: {
			title: 'Edition d\'un client',
			granted: [ 'API_PUT_CLIENT' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/EditShow.vue')
	},
];
